
import React, { useState, useEffect, useRef } from 'react';
import './stylecodForSend.css'

function GetCodeForSendInput(props) {

  const [codeForSend, setCodeForSend] = useState({
    firstInput: '',
    secondInput: '',
    thirdInput: '',
    forthInput: ''
  })

  function onPaste(event) {
    event.preventDefault()
    const pasted = event.clipboardData.getData("text/plain")


    if (!isNaN(pasted) && pasted.length >= 4) {
      setCodeForSend(
        {
          firstInput: pasted[0],
          secondInput: pasted[1],
          thirdInput: pasted[2],
          forthInput: pasted[3],
        })
    } else {
      setCodeForSend(
        {
          firstInput: '',
          secondInput: '',
          thirdInput: '',
          forthInput: '',
        }
      )
    }
  }

  useEffect(() => {
    setCodeForSend({
      firstInput: '',
      secondInput: '',
      thirdInput: '',
      forthInput: ''
    })
  }, [props.getCodeProps.deleteForm])

  const firstInput = useRef(null)
  const secondInput = useRef(null)
  const thirdInput = useRef(null)
  const forthInput = useRef(null)

  useEffect(() => {
    if (codeForSend.firstInput.length < 1) {
      firstInput.current.focus()
    }
  })

  useEffect(() => {
    if (codeForSend.firstInput.length >= 1) {
      secondInput.current.focus()
    }
    var codForSend = codeForSend.firstInput + codeForSend.secondInput + codeForSend.thirdInput + codeForSend.forthInput
    props.setGetCodeProps({ ...props.getCodeProps, codeLogin: codForSend });

  }, [codeForSend.firstInput])

  useEffect(() => {
    if (codeForSend.secondInput.length >= 1) {
      thirdInput.current.focus()
    }
    var codForSend = codeForSend.firstInput + codeForSend.secondInput + codeForSend.thirdInput + codeForSend.forthInput;
    props.setGetCodeProps({ ...props.getCodeProps, codeLogin: codForSend });

  }, [codeForSend.secondInput])

  useEffect(() => {
    if (codeForSend.thirdInput.length >= 1) {
      forthInput.current.focus()
    }
    var codForSend = codeForSend.firstInput + codeForSend.secondInput + codeForSend.thirdInput + codeForSend.forthInput;
    props.setGetCodeProps({ ...props.getCodeProps, codeLogin: codForSend });

  }, [codeForSend.thirdInput])

  useEffect(() => {
    var codForSend = codeForSend.firstInput + codeForSend.secondInput + codeForSend.thirdInput + codeForSend.forthInput
    props.setGetCodeProps({ ...props.getCodeProps, codeLogin: codForSend });

  }, [codeForSend.forthInput])

  const handlChange = (e, item) => {

    if (!isNaN(e.target?.value)) {
      if (item === 'firstInput')
        setCodeForSend({ ...codeForSend, firstInput: e.target.value });
      else if (item === 'secondInput')
        setCodeForSend({ ...codeForSend, secondInput: e.target.value });
      else if (item === 'thirdInput')
        setCodeForSend({ ...codeForSend, thirdInput: e.target.value });
      else if (item === 'forthInput')
        setCodeForSend({ ...codeForSend, forthInput: e.target.value });
    } else {
      setCodeForSend((prevCodeForSend) => {
        if (item === 'firstInput') {
          return { ...prevCodeForSend, firstInput: '' }
        } else if (item === 'secondInput') {
          return { ...prevCodeForSend, secondInput: '' }
        }
        else if (item === 'thirdInput') {
          return { ...prevCodeForSend, thirdInput: '' }
        }
        else if (item === 'forthInput') {
          return { ...prevCodeForSend, forthInput: '' }
        }
      })
    }
  }

  const handleSelect = () => {
    if (codeForSend.firstInput === '') {
      firstInput.current.focus()
    } else if (codeForSend.secondInput === '') {
      secondInput.current.focus()
    } else if (codeForSend.thirdInput === '') {
      thirdInput.current.focus()
    } else if (codeForSend.forthInput === '') {
      forthInput.current.focus()
    } else {
      forthInput.current.focus()
    }
  }

  const handleGetKeyName = (e, item) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      setCodeForSend((prevCodeForSend) => {
        if (item === 'firstInput' && codeForSend.firstInput.length >= 1) {
          return { ...prevCodeForSend, firstInput: '' }
        } else if (item === 'secondInput' && codeForSend.secondInput.length >= 1) {
          return { ...prevCodeForSend, secondInput: '' }
        }
        else if (item === 'thirdInput' && codeForSend.thirdInput.length >= 1) {
          return { ...prevCodeForSend, thirdInput: '' }
        }
        else if (item === 'forthInput' && codeForSend.forthInput.length >= 1) {
          return { ...prevCodeForSend, forthInput: '' }
        } else { return { ...prevCodeForSend } }
      })
      if (item === 'firstInput' && codeForSend.firstInput.length < 1) {
        firstInput.current.focus()
      } else if (item === 'secondInput' && codeForSend.secondInput.length < 1) {
        firstInput.current.focus()
      }
      else if (item === 'thirdInput' && codeForSend.thirdInput.length < 1) {
        secondInput.current.focus()
      }
      else if (item === 'forthInput' && codeForSend.forthInput.length < 1) {
        thirdInput.current.focus()
      }
    } else if (e.key === 'Enter') {
      var codForSend = codeForSend.firstInput + codeForSend.secondInput + codeForSend.thirdInput + codeForSend.forthInput
      //props.callBack(codForSend, 1, e)
    }
  }

  return (
    <>
      <div className='form-inline   justify-content-center ' autoComplete='off' >
        <div className={props.getCodeProps.codeIsValid ?
          'border  rounded-pill  py-2 d-flex justify-content-center bg-white ' :
          'border  rounded-pill  py-2 d-flex justify-content-center border-danger  bg-white '}
          onClick={handleSelect}
          style={{ width: '260px' }} >

          <input className='border-0 test ltr text-center ' placeholder='_' type='tel'
            onKeyDown={(e) => { handleGetKeyName(e, 'forthInput') }}
            style={{ width: '50px' }} maxLength={1} ref={forthInput}
            onChange={(e) => { handlChange(e, 'forthInput') }} value={codeForSend.forthInput}
            onPaste={onPaste} />

          <input className='border-0 test ltr text-center ' placeholder='_' type='tel'
            onKeyDown={(e) => { handleGetKeyName(e, 'thirdInput') }}
            style={{ width: '50px' }} maxLength={1} ref={thirdInput}
            onChange={(e) => { handlChange(e, 'thirdInput') }} value={codeForSend.thirdInput}
            onPaste={onPaste} />

          <input className='border-0 test ltr text-center ' placeholder='_' type='tel'
            onKeyDown={(e) => { handleGetKeyName(e, 'secondInput') }}
            style={{ width: '50px' }} maxLength={1} ref={secondInput}
            onChange={(e) => { handlChange(e, 'secondInput') }} value={codeForSend.secondInput}
            onPaste={onPaste} />

          <input className=' border-0 test ltr text-center ' placeholder='_' type='tel'
            onKeyDown={(e) => { handleGetKeyName(e, 'firstInput') }}
            style={{ width: '50px' }} maxLength={1} ref={firstInput}
            onChange={(e) => { handlChange(e, 'firstInput') }} value={codeForSend.firstInput}
            onPaste={onPaste} />
        </div>
      </div>
    </>
  )
}

export default GetCodeForSendInput